import { refreshTrashEntity } from "@/domain/trash/lib/trash-entity-invalidation";
import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { QueryClient, UseMutateAsyncFunction, useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";

import { permanentlyDeleteEntitiesMutationDocument, PermanentlyDeleteEntitiesResponse } from "./trash.gql";

interface PermanentDeleteInput { entityType: string; idList: string[] }
interface PermanentDeleteResult {
  permanentlyDeleteEntities: UseMutateAsyncFunction<number, Error, PermanentDeleteInput>;
  loading: boolean;
  error: Error | null;
}
export const usePermanentlyDeleteEntities = (workspaceId: string): PermanentDeleteResult => {
  const queryClient: QueryClient = useQueryClient();
  const mutation: UseMutationResult<number, Error, PermanentDeleteInput> = useMutation({
    mutationFn: async (input: { entityType: string; idList: string[] }) => {
      const client = createOperationClient("PermanentlyDeleteEntities");
      const data = await client.request<PermanentlyDeleteEntitiesResponse>(
        permanentlyDeleteEntitiesMutationDocument,
        { input },
      );
      return data.permanentlyDeleteEntities;
    },
    onSuccess: async (_count: number, { entityType, idList }: PermanentDeleteInput): Promise<void> => {
      await refreshTrashEntity({ queryClient, entityType, scope: { workspaceId, idList } });
    },
  });

  return {
    permanentlyDeleteEntities: mutation.mutateAsync,
    loading: mutation.isPending,
    error: mutation.error,
  };
};
